module.exports = __webpack_public_path__ + "static/media/Interstate-Bold.8695a341.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/Interstate-Bold.ttf
// module id = 599
// module chunks = 0